import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SlWapiService } from '../model/api-services/sl-wapi.service';


@Injectable({
	providedIn: 'root'
})
export class UnauthGuard implements CanActivate {

	constructor(
		private router: Router,
		private wapi: SlWapiService
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

		const isPublic: boolean = state.url.indexOf('/public/') > -1;

		if (isPublic) {
			if (this.wapi.HasUnAuthSession()) {
				return true;
			}
			this.wapi.AuthenticatePublicToken().then(() => {
				this.router.navigate([decodeURI(state.url)]);
			}).catch(() => {
				this.wapi.SetAuthTo(decodeURI(state.url));
				this.router.navigate(['/public/']);
			});
			return false;
		}

		if (this.wapi.HasUnAuthCookie() && this.wapi.HasUnAuthSession()) {
			return true;
		}

		if (this.wapi.HasUnAuthCookie() && !this.wapi.HasUnAuthSession()) {
			this.wapi.AuthenticateToken().then(() => {
				this.router.navigate([decodeURI(state.url)]);
			}).catch(() => {
				this.wapi.SetAuthTo(decodeURI(state.url));
				this.router.navigate(['/public/']);
			});
			return false;
		}
		this.wapi.AuthenticateToken().then(() => {
			this.router.navigate([decodeURI(state.url)]);
		}).catch(() => {
			this.router.navigate(['/public/']);
		});
	}
}
